<template>
  <div class="smallFormContainer">
    <h1 class="title is-1" v-if="$route.params.division_id">{{ $t("edit-division") }}</h1>
    <h1 class="title is-1" v-else>{{ $t("new-division") }}</h1>
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-12">
        <label for="firstname">{{ $t("Form.division.name") }}</label>
        <InputText id="firstname" autofocus="true" v-model="division.name" type="text" />
      </div>
      <div class="p-field p-col-6">
        <label for="se_id" class="p-mt-2">{{ $t("Division.abbr") }} </label>
        <InputText id="se_id" autofocus v-model="division.shortcode" type="text" />
      </div>
      <div class="p-field p-col-6">
        <label for="se_id" class="p-mt-2">{{ $t("Division.code") }} </label>
        <InputText id="se_id" autofocus v-model="division.longcode" type="text" />
      </div>
      <div class="p-field p-col-12">
        <label for="lastname">{{ $t("Division.color") }}</label>
        <Picker :value="division.color" @input="updateColor" />
      </div>
      <div v-if="seConnected && !jpLocale" class="p-mt-3 p-col-6">
        <label for="se_id" class="p-mb-2">SportsEngine ID </label>
        <InputText class="p-mt-2" id="se_id" autofocus v-model="division.se_id" type="text" />
      </div>
      <div v-if="seConnected && !jpLocale" class="p-mt-3 p-col-6">
        <label for="se_mapping_code" class="p-mb-2">SportsEngine Mapping Code </label>
        <InputText class="p-mt-2" id="se_mapping_code" autofocus v-model="division.se_mapping_code" type="text" />
      </div>
    </div>
    <div class="p-field p-col-12" v-if="!division.id && currentSeason && currentSeason.divisions.length > 1">
      <label for="lastname">{{ $t("across-division") }}</label>
      <div class="p-field-checkbox">
        <Checkbox
          id="city1"
          :binary="true"
          :disabled="division.id"
          value="true"
          name="city"
          v-model="division.is_across"
        />
        <label for="city1">{{ $t("make-this-an-across-division-mix-two-existing-divisions") }}</label>
      </div>
      <div v-if="division.is_across && !division.id" class="p-mt-4">
        <p>{{ $t("choose-2-divisions") }}</p>
        <div v-for="d in $store.getters.currentSeason.divisions" :key="d.id" class="p-field-checkbox">
          <Checkbox
            v-if="!d.is_across"
            :id="d.name"
            :name="d.name"
            :value="d.id"
            v-model="division.across_divisions"
            :disabled="checkboxDisabled(d)"
          />
          <label v-if="!d.is_across" :for="d.name">{{ d.name }}</label>
        </div>
      </div>
    </div>

    <div class="p-text-center p-mt-5">
      <Button @click="saveDivision" class="p-button-lg" :label="this.$t('Button.save')" :disabled="!isValid" />
    </div>

    <div class="p-text-center p-mt-5">
      <v-popover>
        <Button class="p-button p-button-danger p-button-text" :label="this.$t('delete-division')" />
        <template slot="popover">
          <div class="popover-wrapper">
            <div class="popover-title">{{ $t("confirm-delete-division") }}</div>
            <div class="popover-text">
              {{ $t("division-and-all-of-its-games-will-be-deleted-this-cannot-be-undone") }}
            </div>
            <div class="popover-actions">
              <Button
                class="p-button p-button-danger p-button-text"
                :label="this.$t('delete-division')"
                @click="deleteDivision"
              />
              <Button v-close-popover class="p-button p-button-text" :label="$t('Button.cancel')" />
            </div>
          </div>
        </template>
      </v-popover>
    </div>
    <div class="mt-3">
      <PapaParse @save="doBulk" item="division"></PapaParse>
    </div>
  </div>
</template>

<script>
import api from "@/api";

export default {
  data() {
    return {
      division: {
        name: "",
        color: "",
        se_id: "",
        division_id: null,
        is_across: false,
        across_divisions: [],
        season_id: this.$store.getters.currentSeason.id,
      },
    };
  },
  computed: {
    isValid() {
      return !!this.division.name;
    },
  },
  methods: {
    doBulk(links) {
      console.log("DoBulk", links);
      api
        .createBulkDivisions(this.$store.getters.currentSeason.id, links)
        .then(response => {
          this.makeToast("success", this.$t("Toast.division_created"));
          this.$store.dispatch("getLeagueInformation");
          this.proceed("/");
          console.log(response);
        })
        .catch(error => {
          alert(this.errors);
        });
    },
    checkboxDisabled(d) {
      return this.division.across_divisions.length == 2 && this.division.across_divisions.indexOf(d.id) < 0;
    },
    updateColor(color) {
      this.division.color = color.hex;
    },
    deleteDivision() {
      api
        .deleteDivision(this.division.id)
        .then(response => {
          this.makeToast("info", this.$t("Toast.deleted-division"));
          this.$store.dispatch("getLeagueInformation");
          this.goRouter(`/`);
        })
        .catch(error => {
          this.errors = error.response.data.errors;
          alert(this.errors);
        });
    },
    saveDivision() {
      if (this.division.id) {
        api
          .updateDivision(this.division)
          .then(response => {
            this.makeToast("info", this.$t("Toast.updated-division"));
            this.$store.dispatch("getLeagueInformation");
            this.proceed(`/divisions/` + response.data.id);
          })
          .catch(error => {
            this.errors = error.response.data.errors;
            alert(this.errors);
          });
      } else {
        api
          .createDivision(this.division)
          .then(response => {
            this.makeToast("success", this.$t("Toast.created-division"));
            this.$store.dispatch("getLeagueInformation");
            this.proceed(`/divisions/` + response.data.id);
          })
          .catch(error => {
            this.errors = error.response.data.errors;
            alert(this.errors);
          });
      }
    },
  },
  created() {
    console.log("DivisionID: ", this.$route.params.division_id);
    if (this.$route.params.division_id) {
      api.getDivision(this.$route.params.division_id, this.$store.getters.currentSeason.id).then(response => {
        console.log("Got Division", response.data);
        this.division = response.data;
      });
    }
  },
  mounted() {
    window.analytics.page();
  },
};
</script>

<style scoped lang="scss">
form {
  margin-top: 1rem;
}
</style>
